export const DEFAULT_PAGE_SIZE = 10;

export const CAMPAIGN_TARGETS_PAGE_SIZE = 100;

export const PARTNER_JOURNEY_HISTORY_PAGE_SIZE = 100;

export const ELIGIBLE_BRAND_OPTIONS = [
  { label: 'Deye', value: 'deye' },
  { label: 'GoodWe', value: 'goodwe' },
  { label: 'Growatt', value: 'growatt' },
  { label: 'Solis', value: 'solis' },
] as const;

export const HIGH_REVALIDATION_PCT_THRESHOLD = 15;
